import React, { Component } from 'react'
import Vip from './Vip'
import Subscribe from './Subscribe'
import Record from './Record'
import UpLoad from './Upload'
import UseApp from './UseApp'

import LoginCenter from './LoginCenter'
// import './index.less';
/**
 * 用户中心组件
 */
class HeaderCenter extends Component {
  render () {
    return (
      <div className='g-ucenter' id='uerCenter'>
        <Vip />
        <Subscribe />
        <Record Login={this.props.Login} />
        <UpLoad />
        <UseApp />
        <LoginCenter Login={this.props.Login} />
      </div>
    )
  }
}
export default HeaderCenter
